import { schema } from 'normalizr';
import { LectureComponentListSchema } from './lecture-components';
import { NLecturePage } from '../models/lecture-page';
import { CommunicationListSchema } from './course-communications';

export const LecturePageSchema = new schema.Entity<NLecturePage>('lecturePages', {
  lectureComponents: LectureComponentListSchema,
  communications: CommunicationListSchema,
});

export const LecturePageListSchema = new schema.Array(LecturePageSchema);
